export const userGroups = {
  ADMIN: 2,
  CUSTOMER: 16,
} as const
